import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styles from './dropdown_search_folders.module.scss';
import { withFolderDropdown } from '../../../FoldersDropdownContext';
import { FoldersDropdownContextType } from '../../../foldersDropdown.types';
import { InputSearch } from '../../../../../components/input/input-search/InputSearch';

type Props = {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchValue: FoldersDropdownContextType['searchValue'];
  errorMessage: FoldersDropdownContextType['errorMessage'];
};

export const RawDropdownSearchFolders: FC<Props> = ({
  handleChange,
  searchValue,
  errorMessage,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <InputSearch
        autoFocus
        value={searchValue}
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: 'search/DropdownSearchFolders.tsx/1',
        })}
      />
      {errorMessage && (
        <div className={`form-error is-visible ${styles.error}`}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export const DropdownSearchFolders = withFolderDropdown(
  RawDropdownSearchFolders,
);
